import { render, staticRenderFns } from "./tfBookSelect.vue?vue&type=template&id=23bef3e7&scoped=true"
import script from "./tfBookSelect.vue?vue&type=script&lang=js"
export * from "./tfBookSelect.vue?vue&type=script&lang=js"
import style0 from "./tfBookSelect.vue?vue&type=style&index=0&id=23bef3e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bef3e7",
  null
  
)

export default component.exports